import getFormatNumber from "../../../../utils/helperFunctions/getFormatedNumber";

type TooltipPayload = {
  opacity: number;
  label: number;
};

const CustomTooltip = ({
  active,
  payload,
  label,
  unit = "Articles",
  activeLegend,
}: any) => {
  if (!active && !payload && !payload.length) return null;

  const dynamicUnitRenderer = (legend: string) => {
    switch (legend) {
      case "printNoOfArticles":
        return "Articles";
      case "digitaltvNoOfArticles":
        return "Articles";
      case "tvNoOfArticles":
        return "Broadcasts";
      case "radioNoOfArticles":
        return "Episodes";
    }
  };

  const activeData = payload?.find(
    (item: TooltipPayload) => item.opacity === 1
  );

  return (
    <div className="custom-tooltip flex flex-col justify-between gap-[4px] px-4 py-2 bg-white font-poppins rounded-md border border-solid border-gray shadow-md">
      <p className="label text-black text-xs font-bold ">{`${label}`}</p>
      <p className="desc font-bold text-hardGrey ">
        {/* {activeData?.value} */}
        {unit === "legend" ? dynamicUnitRenderer(activeLegend) : unit}:{" "}
        {parseInt(activeData?.value || 0)}
      </p>
    </div>
  );
};

export const customTooltipGoogleCharts = (
  label: string,
  value: number,
  total: number
) => {
  return `<div class="custom-tooltip flex flex-col justify-between gap-[4px] px-4 py-2 bg-white font-poppins rounded-md border border-solid border-gray shadow-md">
      <p class="label w-full block text-black text-xs font-bold text-nowrap">${label}</p>
      <p class="desc text-lg font-bold text-hardGrey " >
      ${value} (${Math.round((value / total) * 100)})%
      </p>
    </div>`;
};

export const CustomBarTooltip = ({
  active,
  payload,
  label,
  unit = "AVE",
  stackedMode = false,
}: any) => {
  if (!active && !payload && !payload.length) return null;

  const activeData = payload[0];  

  return (
    <div className="custom-tooltip flex flex-col justify-between gap-[4px] px-4 py-2 bg-white font-poppins rounded-md border border-solid border-gray shadow-md">
      <p className="label text-black text-xs font-bold ">{`${label}`}</p>
      {stackedMode ? (
        payload?.map((payloadItem: any) => (
          <p
            className={`desc font-bold text-[hardGrey] `}
            style={{ color: payloadItem.color }}
          >
            {payloadItem?.unit}: $
            {typeof payloadItem?.value === "number"
              ? getFormatNumber(payloadItem?.value || 0)
              : getFormatNumber(payloadItem?.value || 0)}
          </p>
        ))
      ) : (
        <p className="desc font-bold text-hardGrey ">
          {unit}: ${getFormatNumber(activeData?.value || 0)}
        </p>
      )}
    </div>
  );
}; 

export default CustomTooltip;
